module.exports = __webpack_public_path__ + "assets/karbonmonoksit.a0ee2627.svg";